import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import API, { formatPrice } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const OrderSuccess = () => {
  const { id } = useParams();
  const { user } = useAuth();
  const [order, setOrder] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (user) API.get(`/orders/${id}`).then((r) => setOrder(r.data)).catch(() => setOrder(null));
  }, [id, user]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#faf7f2] px-4 pb-16 pt-[100px]" data-testid="order-success-page">
      {!user ? (
        <div className="text-center">
          <p className="text-[#6b5b52]">Inicia sesión para ver tu pedido.</p>
          <Link to="/iniciar-sesion" className="mt-4 inline-block rounded-full bg-[#4b3a2f] px-8 py-3 text-sm text-[#f2e9dd]">Iniciar sesión</Link>
        </div>
      ) : !order ? (
        <p className="animate-pulse text-[#6b5b52]">Cargando pedido…</p>
      ) : (
        <div className="w-full max-w-lg rounded-3xl border border-[#e8ded4] bg-white p-10 text-center shadow-[0_20px_60px_rgba(75,58,47,0.12)]">
          <span className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-[#3b7a57]/10 text-[#3b7a57]">
            <CheckCircle2 size={40} />
          </span>
          <h1 className="mt-6 font-serif-d text-4xl font-semibold text-[#4b3a2f]">¡Gracias, {order.user_name?.split(" ")[0]}!</h1>
          <p className="mt-3 text-sm text-[#6b5b52]">
            Tu pago se completó con éxito. Muy pronto te contactaremos por WhatsApp para coordinar tu sesión o darte acceso a tu curso.
          </p>
          <div className="mt-8 space-y-3 rounded-2xl bg-[#faf7f2] p-6 text-left text-sm">
            <p className="font-mono-d text-[10px] uppercase tracking-widest text-[#a47b52]">Pedido #{order.id.slice(-8).toUpperCase()}</p>
            {order.items.map((i) => (
              <div key={i.product_id} className="flex justify-between text-[#4b3a2f]">
                <span>{i.title} ×{i.quantity}</span>
                <span>{formatPrice(i.price * i.quantity)}</span>
              </div>
            ))}
            <div className="flex justify-between border-t border-[#e8ded4] pt-3 font-semibold text-[#4b3a2f]">
              <span>Total pagado</span><span data-testid="order-success-total">{formatPrice(order.total)} USD</span>
            </div>
          </div>
          <Link to="/catalogo" data-testid="order-success-back" className="mt-8 inline-block rounded-full bg-[#4b3a2f] px-8 py-3.5 text-sm font-semibold text-[#f2e9dd] transition-colors hover:bg-[#c9a24b] hover:text-[#4b3a2f]">
            Seguir explorando
          </Link>
        </div>
      )}
    </div>
  );
};

export default OrderSuccess;
